const ColorsCircles = (props) => {
  const { colors } = props;

  return (
    <div className={colors ? colors : "none"}>
      <div></div>
    </div>
  );
};

export default ColorsCircles;
